<template>
  <section
    :data-background-video="videoUrl"
    :data-background-image="gifUrl"
    data-background-video-loop="true"
    data-background-opacity="0.4"
    id="upcomingharvestslide"
  >
    <div
      class="sl-block"
      data-block-type="text"
      style="width: 100%; left: 29px; top: 84px; height: auto"
    >
      <div
        class="sl-block-content"
        data-placeholder-tag="h2"
        data-placeholder-text="Title Text"
        style="text-align: left; z-index: 10"
        dir="ui"
      >
        <h2 style="text-align:center">Upcoming Harvests</h2>
      </div>
    </div>

    <div
      class="sl-block"
      data-block-type="table"
      style="
        height: auto;
        min-width: 120px;
        width: 100%;
        left: 29px;
        top: 175.5px;
      "
    >
      <table>
        <tbody>
          <tr v-for="harvest in harvestSchedule" :key="'lc' + harvest.id">
            <td style="font-size: 0.9em">{{moment(harvest.harvestdate).fromNow()}}</td>
            <td style="font-size: 0.9em">{{harvest.rack}}</td>
            <td style="font-size: 0.9em">{{harvest.cropname}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import Trimaster from "@/plugins/servers/trimaster.js";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "",
  props: ["value"],
  components: {},
  beforeMount() {
    if (navigator.userAgent.indexOf("Silk") > 0) {
      this.gifUrl = "/img/presentationbackgrounds/harvestTime.gif";
    } else {
      this.videoUrl = "/img/presentationbackgrounds/harvestTime.mp4";
    }
    this.refresh();
  },
  mounted() {},
  data() {
    return {
      moment: moment,
      harvestSchedule: [],
      gifUrl: null,
      videoUrl: null,
    };
  },

  computed: {
    ...mapGetters(["getUser"]),
  },
  watch: {},
  methods: {
    refresh() {
      let me = this;
      Trimaster.get("vFacilityLifecycles", this.getUser.apitoken, {
        filter: {
          limit: 7,
          order: 'harvestdate',
          where: {
            facility_id: this.getUser.facility_id,
            mother: false,
            inflight: 1,
            actualHarvestDate: null,
            plants : {gt : 0}
          },
        },
      }).then(function ([res, err]) {
        me.harvestSchedule = res;
      });
    },
  },
};
</script>
<style>
</style>

